import React from 'react';
import { DataTable, Typography } from 'vindi-ds-components';
import toBrl from '@utils/format_currency';

const priceColumns = [
  {
    field: 'start_quantity',
    headerName: 'Entre',
    width: 148,
  },
  {
    field: 'end_quantity',
    headerName: 'E',
    width: 148,
    renderCell: ({ value }) => <> { value || 'Sem término' } </>,
  },
  {
    field: 'price',
    headerName: 'Cobrar',
    renderCell: ({ value }) => <> { toBrl(value) } </>,
    width: 148,
  },
  {
    field: 'overage_price',
    headerName: 'Excedente',
    renderCell: ({ value }) => <> { value ? toBrl(value) : '-' } </>,
    width: 148,
  },
];

function handlePage(rows) {
  return new Promise((resolve) => {
    const data = {
      rows,
      length: rows.length,
    };
    resolve(data);
  });
}

function PricingTable({ pricingRanges }) {
  return (
    <>
      <Typography variant='subtitle1' component='h2'>
        Faixas de preço
      </Typography>
      <DataTable columns={priceColumns} handlePages={() => handlePage(pricingRanges)} />
    </>
  );
}

export default PricingTable;
